export default __webpack_public_path__ + "static/media/power-off-solid.64f21014.svg";